import Image from 'next/image';
import React from 'react';
import { useSettings } from '@/contexts/settings';
import { useReservation } from '@/contexts/reservation';

const PercentOff: React.FC = () => {
  const { pixDiscount, creditCardDiscount } = useSettings();
  const { paymentMethod } = useReservation();

  // Determine the discount percentage based on payment method
  const percentageOff = paymentMethod === 'pix' ? pixDiscount :
    paymentMethod === 'creditCard' ? creditCardDiscount : 0;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '63px',
      height: '18px',
      backgroundColor: '#08AC88',
      borderRadius: '10px',
      color: 'white',
      fontSize: '10px',
      fontWeight: 'bold',
      padding: '0 4px',
    }}>
      <Image
        src="/icons/percent-icon.svg"
        alt="Percent Icon"
        width={10}
        height={10}
      />
      <span style={{ margin: '0 2px' }}>{percentageOff}%</span>
      <span>OFF</span>
    </div>
  );
};

export default PercentOff;